import { DOCUMENT } from '@angular/common';
import { Meta } from '@angular/platform-browser';
import { AfterViewChecked, AfterViewInit, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import localeDE from '@angular/common/locales/de';
import localeEN from '@angular/common/locales/en';
import { Message, MessageService } from 'primeng/api';
import { SwUpdate } from '@angular/service-worker';
import { registerLocaleData } from "@angular/common";
import { Observable } from "rxjs";
import { Messages } from "primeng/messages";
import { GLOBALS } from "./app-globals";
import { AuthService } from "./skitbs/base/auth/auth.service";
import { RestClient } from "./skitbs/rest-client.service";

/**
 * App-Component
 */
@Component({
    selector: 'app-root',
    template: `
        <div class="content Hei100" role="main">
            <router-outlet></router-outlet>

            <!-- Global messages -->
            <p-messages *ngIf="false" [(value)]="globalMessages" styleClass="BsTexBreakAll BsFsSmall"></p-messages>

            <!-- Global toast-messages -->
            <p-toast key="toast-messages" closable="false" position="bottom-center" [showTransitionOptions]="'100ms'" [hideTransitionOptions]="'700ms'">
                <ng-template let-pMessage pTemplate="pMessage">
                  <div [innerHtml]="pMessage.detail"></div>
                </ng-template>
            </p-toast>

            <!-- Global dialog-messages -->
            <p-dialog *ngIf="true" header="Warnung" styleClass="BsDialogError" [(visible)]="showErrorDialog" #_dlgErrors
                      [breakpoints]="{'960px': '75vw', '640px': '95vw'}" [style]="{width: '50vw'}"><span>{{globalMessagesStr}}</span>
            </p-dialog>

            <!-- Global busy-spinner -->
            <skitbs-busy></skitbs-busy>
        </div>
    `
})
export class AppComponent implements OnInit, OnDestroy {
    title = 'skitdk-my-version-1';
    globalMessages: Message[] = [];
    showErrorDialog: boolean = false;
    showBusy: Observable<boolean>;
    private unreadCountRequestActive = false;
    private windowFocusHandler = () => this.refreshUnreadMessageCount();
    private visibilityChangeHandler = () => {
        if (!this.document.hidden) {
            this.refreshUnreadMessageCount();
        }
    };


    /**
     * Constructor
     */
    constructor(private messageService: MessageService, private swUpdate: SwUpdate, @Inject(DOCUMENT) private document: Document, private meta: Meta,
                private authService: AuthService, private restClient: RestClient) {
        console.log("[AppComponent] instance CREATED !");

        // prevents Google-Translation +
        this.meta.addTag({ 'http-Equiv': 'content-language', content: GLOBALS.i18n.lang });
        this.document.documentElement.lang = GLOBALS.i18n.lang;

        // multi-locale for formatDate etc.
        registerLocaleData(localeDE);
        registerLocaleData(localeEN);
    }


    /**
     * Lifecycle.
     */
    ngOnInit() {
        console.log("[AppComponent] instance OnInit!");
        //-- initial welcome-message
        this.globalMessages = [{ severity: "info", summary: "[Message]", detail: "Welcome app-message !" }];
        this.globalMessages = [{}];

        // subscribe for messages
        this.messageService.messageObserver.subscribe((aMessage: Message) => {
            console.log("onSubscribe: " + aMessage.detail);
            this.globalMessages = [];
            if (aMessage.severity == 'error') {
                this.globalMessages = [aMessage];
                if (aMessage.data == 'open_in_dialog') {
                    this.showErrorDialog = true;
                }
            }
        });

        this.checkAppUpdate();
        window.addEventListener('focus', this.windowFocusHandler);
        this.document.addEventListener('visibilitychange', this.visibilityChangeHandler);
    }

    ngOnDestroy(): void {
        window.removeEventListener('focus', this.windowFocusHandler);
        this.document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
    }

    private refreshUnreadMessageCount(): void {
        const pSession = this.authService.findCurrentSession();
        if (this.document.hidden || !pSession || !this.authService.getToken() || this.unreadCountRequestActive) {
            return;
        }

        this.unreadCountRequestActive = true;
        this.restClient.unreadMessageCount().subscribe({
            next: count => {
                const pCurrentSession = this.authService.findCurrentSession();
                if (pCurrentSession && pCurrentSession.tenantNr === pSession.tenantNr && pCurrentSession.cpNr === pSession.cpNr) {
                    this.authService.updateIncomingMessages(count);
                }
            },
            error: () => this.unreadCountRequestActive = false,
            complete: () => this.unreadCountRequestActive = false
        });
    }

    /**
     * Messages toString.
     */
    get globalMessagesStr() {
        var pBuf: string | undefined;
        if (this.globalMessages != null) {
            this.globalMessages.forEach(aMsg => pBuf = aMsg.detail);
        }
        return pBuf
    }

    /**
     * Gets Version.
     */
    get appVersion() {
        return "0.0.1"
    }


    /**
     * Checks for updates.
     * @private
     */
    private checkAppUpdate() {
        console.log("[AppComponent] Update-check!");

        // Check for update-type
        this.swUpdate.versionUpdates.subscribe(evt => {
            console.log("[App-Updater] update-event:" + evt.type);
            switch (evt.type) {
                case 'VERSION_DETECTED':
                    console.log(`[App-Updater] Downloading new app version: ${evt.version.hash}`);
                    break;
                case 'VERSION_READY':
                    console.log(`[App-Updater] Current app version: ${evt.currentVersion.hash}`);
                    console.log(`[App-Updater] New app version ready for use: ${evt.latestVersion.hash}`);
                    break;
                case 'VERSION_INSTALLATION_FAILED':
                    console.log(`[App-Updater] Failed to install app version '${evt.version.hash}': ${evt.error}`);
                    break;
            }
        });


        // Update app when available
        this.swUpdate.available.subscribe((event) => {
            console.log('current version: ', event.current);
            console.log('available version: ', event.available);

            // auto-update
            var pAskForUpdate = false;
            if (!pAskForUpdate) {
                this.swUpdate.activateUpdate().then(() => {
                    window.location.reload();
                    alert("New version of App was installed!");
                });
                return;
            }

            // ask for update ?
            if (confirm('Install new App version ?')) {
                this.swUpdate.activateUpdate().then(() => {
                    window.location.reload();
                    alert("New version of App was installed!");
                });
            }
        });
    }

}
